import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDownloadIconWithoutBg = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	stroke: "#787878",
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M9.31982 11.6797L11.8798 14.2397L14.4398 11.6797",
			strokeWidth: 1.5,
			strokeMiterlimit: 10,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M11.8799 4V14.17",
			strokeWidth: 1.5,
			strokeMiterlimit: 10,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M20 12.1797C20 16.5997 17 20.1797 12 20.1797C7 20.1797 4 16.5997 4 12.1797",
			strokeWidth: 1.5,
			strokeMiterlimit: 10,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgDownloadIconWithoutBg;
